import { render, staticRenderFns } from "./InstituitionStaffList.vue?vue&type=template&id=4f055f39"
import script from "./InstituitionStaffList.vue?vue&type=script&lang=js"
export * from "./InstituitionStaffList.vue?vue&type=script&lang=js"
import style0 from "./InstituitionStaffList.vue?vue&type=style&index=0&id=4f055f39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports